const pendingScheduleWriteIds = new Set<string>();
const pendingScheduleDeleteIds = new Set<string>();

export function markPendingScheduleWrite(id: string): void {
    pendingScheduleWriteIds.add(id);
    pendingScheduleDeleteIds.delete(id);
}

export function markPendingScheduleDelete(id: string): void {
    pendingScheduleDeleteIds.add(id);
    pendingScheduleWriteIds.delete(id);
}

export function clearPendingScheduleWrite(id: string): void {
    pendingScheduleWriteIds.delete(id);
}

export function clearPendingScheduleWrites(): void {
    pendingScheduleWriteIds.clear();
    pendingScheduleDeleteIds.clear();
}

export function isPendingScheduleWrite(id: string): boolean {
    return pendingScheduleWriteIds.has(id);
}

export function isPendingScheduleDelete(id: string): boolean {
    return pendingScheduleDeleteIds.has(id);
}

export function clearPendingScheduleDeletesMissingFromRemote(remoteIds: Set<string>): void {
    for (const id of pendingScheduleDeleteIds) {
        if (!remoteIds.has(id)) {
            pendingScheduleDeleteIds.delete(id);
        }
    }
}
